module.exports = __webpack_public_path__ + "static/media/highprecisionbc.05a82668.jpg";